// LIBRERIE/IMPORTS
import React from "react";
import { useTranslation } from "react-i18next";

interface Agent {
    img: string;
    name: string;
    tel?: string;
    mobile?: string;
    email?: string;
}

interface AgentsSectionProps {
    showAgents: boolean;
    agents: Agent[];
    agentsLoading: boolean;
    agentsError: string | null;
}

const AgentsSection: React.FC<AgentsSectionProps> = ({ showAgents, agents, agentsLoading, agentsError }) => {
    const { t } = useTranslation();

    if (!showAgents) return null;

    console.log(agents);
    return (
        (agentsLoading || agentsError || agents.length > 0) ? (
            <section>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <div className="section-title text-center">
                                <h2>{t('agents.sectionTitle')}</h2>
                            </div>
                        </div>
                    </div>

                    {agentsLoading ? (
                        <div className="text-center">{t('agents.loadingAgents')}...</div>
                    ) : agentsError ? (
                        <div className="text-center text-danger">{agentsError}</div>
                    ) : (
                        <div className="row no-gutters justify-content-center">
                            {agents.map((agent, index) => (
                                <div key={index} className="agent-card" style={{backgroundImage: `url(${agent.img})`}}>
                                    <div className="w-100 text-center bg-overlay-black-30">
                                        <p className="my-3">{agent.name}</p>
                                        <div className="mb-3">
                                            <a href={`mailto:${agent.email}`}>{agent.email}</a>
                                        </div>
                                        <div className="mb-3">
                                            <a href={`tel:${agent.tel}`}>{agent.tel}</a>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </section>
        ) : null
    );
};

export default AgentsSection;